import React, { Fragment } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table"
import { Table } from "reactstrap"
// Define a default UI for filtering
const TableContainer = ({
  columns,
  data,
  customPageSize,
  pageindex,
  totalCount,
  sethideHeader,
  toggleViewModal,
  hideDateColumn,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    footerGroups,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: pageindex,
        pageSize: customPageSize,
        hiddenColumns: hideDateColumn == true ? ["date"] : [],
        sortBy: [
          {
            desc: true,
          },
        ],
      },
      manualPagination: true,
      pageCount: Math.ceil(totalCount / customPageSize),
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  const getSelectedRowwValues = selectedRow => {
    if (sethideHeader == true) {
      toggleViewModal({ ...selectedRow.original }, page)
    }
    if (!sethideHeader == true) {
      toggleViewModal({ ...selectedRow.original }, page)
    }
  }

  const generateSortingIndicator = column => {
    return column.sort ? <i className={column.isSortedDesc ? "bx bx-sort-down" : "bx bx-sort-up"}></i> : ""
  }

  return (
    <Fragment>
      <div
        className={
          hideDateColumn !== true
            ? "common_table_align table-responsive react-table custom_table_myteams_filter "
            : "table-responsive react-table custom_table_teams"
        }
      // style={{ overflowX: "clip" }}
      >
        <Table bordered hover {...getTableProps()}>
          <thead className="table-light table-center">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    className={
                      sethideHeader == true
                        ? "d-none header-hide-date"
                        : "text-center header-hide-row"
                    }
                    {...column.getSortByToggleProps({
                      style: {
                        minWidth: column.minWidth,
                        width: column.width,
                      },
                    })}
                  >
                    {column.render("Header")}
                    {generateSortingIndicator(column)}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {sethideHeader !== true && (
            <tfoot>
              {footerGroups.map(group => (
                <tr {...group.getFooterGroupProps()} key={group.id}>
                  {group.headers.map(column => (
                    <td {...column.getFooterProps()} key={group.id}>
                      {column.render("Footer")}
                    </td>
                  ))}
                </tr>
              ))}
            </tfoot>
          )}
          <tbody {...getTableBodyProps()}>
            {(page.length > 0 &&
              page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr
                      style={
                        row.isExpanded && {
                          background: "#F9E3CD",
                          cursor: "pointer",
                        }
                      }
                      {...row.getRowProps()}
                      onClick={e => {
                        {
                          ; (e.target.cellIndex || e.target.cellIndex === 0) &&
                            getSelectedRowwValues(row)
                        }
                      }}
                    >
                      {row.cells.map(cell => {
                        return (
                          <td key={cell.id} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })) || (
                <tr>
                  <td
                    colSpan={"11"}
                    className="react-bs-table-no-data text-center"
                  >
                    Sorry, There are no data to display
                  </td>
                </tr>
              )}
          </tbody>
        </Table>
      </div>
    </Fragment>
  )
}

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default TableContainer
